import React from 'react'
import Particles from 'react-tsparticles'
import particles from '../assets/particles'

const ParticlesBG = () => {
  return (
    <Particles params={particles}>
    </Particles>
  )
}

export default ParticlesBG